<template>
  <div class="cart orderList reservationList">
    <h1 class="boxTitle mb15 notranslate">{{locale.reservation_list}}</h1>
    <div v-if="list.length" class="list">
      <ReservationItem
        v-for="item in list"
        :key="item.order_id"
        :order="item"
        :locale="locale"
        :lang="lang"
        @cancel="cancel" />
    </div>
    <div v-else class="noData notranslate">{{locale.reservation_nodata}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReservationItem from '@/components/Mypage/ReservationItem'

export default {
  name: 'ReservationList',
  props: [
    'lang',
    'locale'
  ],
  components: {
    ReservationItem
  },
  computed: {
    ...mapGetters({
      metaInfo: 'authentication/getMetaInfo'
    })
  },
  async mounted () {
    this.init()
  },
  data () {
    return {
      list: [],
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'orderList'
      })
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    async init () {
      this.track()
      this.$store.commit('loading', true)
      await this.getKey()
      this.$store.dispatch('submit/getOrderHistory').then((res) => {
        if (res && res.orderLog && res.paidLog) {
          this.list = res.orderLog.filter(x => x.order_type.includes('reservation')) || []
        }
        this.$store.commit('loading', false)
      })
    },
    cancel (id) {
      this.$store.dispatch('reservation/cancelReservation', id).then((res) => {
        if (res) {
          alert(this.locale.alert_complete_reservation_cancel)
          this.init()
        } else {
          alert(this.alert_system_error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  text-align: center;
}
</style>
